import { Component, Inject } from '@angular/core'

@Component({
  selector: 'app-map-navigation-item',
  templateUrl: './map-navigation-item.component.html',
  styleUrls: ['./map-navigation-item.component.scss'],
  standalone: false,
})
export class MapNavigationItemComponent {}
